import React from "react";
import { useFormik } from 'formik'
import { UserContext } from '../context/UserContext'
import css from './Login.module.css'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { linkApi } from '../config'

const LoginModal = () => {
    const [loginFail, setLoginFail] = useState(false)
    const { setUser } = React.useContext(UserContext)
    const navigator = useNavigate()

    const postData = async (query) => {
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(query),
        }

        await fetch(`${linkApi}/v1/users/login`, options)
            .then((response) =>
                response.status === 200 ? response.json() : setLoginFail(true)
            )
            .then(async (response) => {
                console.log('res12312', response)
                setUser((prev) => ({
                    ...prev,
                    login: 'true',
                    token: response.data.token,
                }))

                navigator('/')
            })
            .catch((erro) => console.log('erro', erro))
    }

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: async (values) => {
            postData(values)
        },
    })

    return (
        <div className="App col-ms-8">
            <div className={css.title}>Editor de Anúncios Carmine</div>
            <form onSubmit={formik.handleSubmit}>
                <div className={css.forFlex}>
                    {loginFail && 'Login errado'}

                    <InputText
                        id="email"
                        name="email"
                        type="email"
                        className="p-inputtext-lg"
                        style={{ fontSize: '12px', marginBottom: '10px' }}
                        placeholder="E-mail"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                    />

                    <InputText
                        id="password"
                        name="password"
                        type="password"
                        className="p-inputtext-lg"
                        style={{ fontSize: '12px' }}
                        placeholder="Password"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                    />
                </div>
                <Button type="submit" style={{ marginTop: '40px' }}>
                    Submeter
                </Button>
            </form>
        </div>
    )
}

export default LoginModal;
